module.exports = __webpack_public_path__ + "static/media/Jack-sitting.97491f2f.png";